import { tvpil } from '../compat/tvpil';

export function useImageTypeRatio(imageType: number) {
  return tvpil.imageTypes.find((type) => type.id === imageType)?.ratio;
}
